import React from "react"

export default function StrengthTestPrize() {
  return <>StrengthTest Prize</>
}
